export const version = '6.6-beta.1777';
